// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2jlwD","left":"StickyBox_left__1vmey","right":"StickyBox_right__2tvGq"};